'use client'

import { useAuthorization } from '@entities/authentication'
import { tutorExclusionMutations, tutorExclusionQueries } from '@entities/tutor-exclusion'
import { track } from '@shared/analytics'
import { useTranslation } from '@shared/config/i18n'
import { EVENT_IDS } from '@shared/constants'
import { useToast } from '@shared/hooks'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface UseUnblockTutorOptions {
  location?: string
}

export const useUnblockTutor = ({ location = 'unknown' }: UseUnblockTutorOptions = {}) => {
  const queryClient = useQueryClient()
  const { bearerToken } = useAuthorization()
  const { toast } = useToast()
  const t = useTranslation()

  return useMutation({
    ...tutorExclusionMutations.unblockTutor({ bearerToken }),
    onSuccess: (_, tutorId) => {
      toast({ title: t('tutorExclusion.toast.unblockSuccess') })
      track(EVENT_IDS.TUTOR_UNBLOCKED, { tutorId, location })
    },
    onError: (error, tutorId) => {
      toast({ title: t('tutorExclusion.toast.unblockFail') })
      track(EVENT_IDS.TUTOR_UNBLOCK_FAILED, {
        tutorId,
        error: error instanceof Error ? error.message : String(error),
        location,
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: tutorExclusionQueries.all })
    },
  })
}
